// 按页面划分
export default {
    // 公共页面
    common: {
        title:"Ma'lumot savdo markazi",
        pull_refresh: 'Yangilash uchun pastga torting',
        release_refresh: 'Yangilash uchun chiqaring',
        refresh_loading: 'Yuklash ...',
        footer_text: 'Xizmatlar Ucloudlink (NASDAQ: UCL) tomonidan taqdim etiladi'
      },
      home: {
        input_placeholder: 'Mamlakat / mintaqani qidirish',
        my_flow: 'Mening oqimim',
        charge_code: 'Vaucher kodi',
        coupons:'Kuponlar',
        local_package: 'Mahalliy ma\'lumotlar',
        more: 'Ko\'proq',
        popular_destination: 'Mamlakat / mintaqa',
        buy_now: 'Hozir xarid qilish',
        package_useing: 'Faol',
        unused: 'Faol emas',
        download_app: 'Ilovani yuklab olish',
        enter_the_mall_list: 'Savdo markaziga o\'ting',
        no_data: 'Hali ma\'lumot yo\'q',
        no_data_available: "Ma'lumotlar mavjud emas",
        copy_success: 'Muvaffaqiyatli nusxa ko\'chirildi',
        copy_fail: 'Nusxa ko\'chirish muvaffaqiyatsiz tugadi',
        meritsTitle: 'Foydalanish afzalliklari nimalar?',
        merits1: 'SIM kerak emas & Oylik to\'lov yo\'q',
        merits2: 'Eng yaxshi 2-3 operator bilan integratsiya qilingan, avtomatik tarmoq almashinuvi',
        go_buy: 'Sotib olmoq',
        instant_savings: 'Tejal',
        expires_in: 'Muddati tugashi',
        download_app_tips: "Ilovani yuklab oling, ko'proq takliflar va tajribalar oling"
      },
      packages: {
        sub_title: {
          us: 'Guam, Saipandan tashqari',
          it: 'Shu jumladan Vatican shahri, San-Marino',
          va: 'Shu jumladan Italiya, San Marino',
          sm: 'Shu jumladan Italiya, Vatikan shahar',
          ma: 'Shu jumladan g\'arbiy Sahra',
          eh: 'Marokashni o\'z ichiga oladi',
          ch: 'Shu jumladan Lichenshteyn',
          li: 'Shu jumladan Shveytsariya',
          fr: 'Shu jumladan Monako',
          mc: 'Frantsiya o\'z ichiga',
          fi: 'Shu jumladan Aland orollari',
          ax: 'Finlyandiya ham',
          gu: 'Shu jumladan Shimoliy Marian orollari',
          mp: 'Shu jumladan Guam'
        },
        unlimited_packages: 'Cheksiz ma\'lumotlar to\'plami',
        normal_packages: 'Oddiy ma\'lumotlar to\'plami',
        multi_region_packages: 'Ko\'p qirrali',
        regional_data: 'Hududiy ma\'lumotlar',
        high_speed_text: 'Yuqori tezlikdagi ma\'lumotlar',
        infiniteFlow:'Cheksiz ma\'lumotlar',
        unLimitData: 'Cheksiz',
        high_speed_text_year: 'Yuqori tezlik / mp',
        package_list: 'Paketlar ro\'yxati',
        special_offer: 'Chegirma',
        first_month: '1-Oy',
        periodUnit: {
          day: 'kun (lar)',
          month: 'oy',
          hour: 'soat (lar)',
          year: 'yil',
        },
        periodUnits: {
          day: 'kun (lar)',
          month: 'oylar',
          hour: 'soat (lar)',
          year: 'yillar',
        },
        periodUnitSimp: {
          day: 'dum',
          month: 'mor',
          hour: 'r',
          year: 'darrov'
        },
        periodUnitMonthly:'Oylik',
        periodUnitsSimp: {
          day: 'dum',
          month: 'mor',
          hour: 'r',
          year: 'darrov'
        },
        unlimited_good_name: {
          day: 'Kun o\'tishi',
          month: 'Oylik o\'tish',
          year: 'Yillik o\'tish'
        },
        continuousMonth : "Uzluksiz oylar",
        continuousDay : "Uzluksiz kunlar",
        continuousYear:"Uzluksiz yillar",
        
        
        day_invalid: 'Hozirgi kunda tugaydi',
        month_invalid: 'Joriy oyda tugaydi',
        immediate_valid: 'Darhol samarali',
        tomorrow_day_valid: 'Ertasi kundan amal qiladi',
        tomorrow_month_valid: 'Keyingi oydan amal qiladi',
    
    
        // detail page
        detail: {
          cell_flow: 'Ma\'lumotlar',
          cell_period: 'Yaroqlilik',
          buy_quantity: 'Miqdori',
          use_area: 'Qoplama',
          use_intro: 'Foydalanish shartlari',
          buy_btn: 'Tartib',
          pay: 'To\'lov',
          buy_tips: 'Sizda %@packageName paketi ishlatilmoqda. Ushbu paketni sotib olishni xohlaysizmi?',
          haveOrderTips: "To'lov kutayotgan buyurtma yaratildi. Tasdiqlashni bosing va Mening ma'lumotlar sahifamga o'ting！"
        },
    
        // confirm page
        confirm: {
          title: 'Buyurtma tasdiqlash',
          real_pay_amount: 'To\'langan summa',
          online_payment: 'Onlayn to\'lov',
          create_order_error: 'O\'rnatish muvaffaqiyatsiz tugadi'
        }
      },
      pay: {
        // result page
        result: {
          loading_order_status: 'Buyurtma holatini olish ...',
          buy_success: 'Buyurtma tugadi',
          buy_pending: 'Kutilayotgan tasdiqlash',
          buy_pending_tip: 'To\'lov jarayonida ... Agar to\'lov 10 daqiqada o\'tkazilmasa, iltimos biz bilan bog\'laning.',
          get_payment_info_fail: 'To\'lov haqida ma\'lumot olish amalga oshmadi',
          cell_package: 'Paket',
          cell_buy_amount: 'Subtotal',
          cell_real_amount: 'To\'langan summa',
          go_to_order_btn: 'Paketimga o\'ting',
          back_home: 'Uyga qaytish',
          back_mall: 'Savdo markaziga qaytish',
          ordersn_empty: 'Buyurtma sn bo\'sh bo\'lolmaydi',
          order_search_error: 'Kutilmagan xato',
          goodsName: 'Mahsulot nomi'
        },
    
        //fail page
        fail: {
          payment_fail: 'To\'lov amalga oshmadi',
          //payment_fail_desc: '请返回商品页面，重新购买',
          back_home: 'Uyga qaytish'
        }
      },
      CountryGroup: {
        title: "Mamlakat / mintaqa",
        placeholder: "Mamlakat yoki mintaqani qidirish",
        clear: "Aniq",
        history: "Qidiruv tarixi"
      },
      PromotionCode: {
        verification: {
          title: 'Vaucher kodi',
          minititle:'Vaucher kodi',
          input: 'Yuqoridagi kodni kiriting',
          explain: 'Maslahatlar: QR kodini skanerlash uchun eng yuqori o\'ng tugmachani bosing yoki agar u ishlamasa, vaucher kodini (harflar sezgir) kiriting.',
          submit: 'Topshirmoq',
          exchange: 'Qaytarib olmoq',
          cancel: 'Bekor qilmoq',
          Inquiry: "Almashishingizga ishonchingiz komilmi?",
          ErrorCode: 'Qayta to\'ldirish xatosi',
        },
        recharge_success: {
          package: 'Paket',
          content: 'Muvaffaqiyatli sotib olingan',
          back: 'Savdo markaziga qaytish',
          view_packets: 'Paketimga o\'ting'
        }
      },
      order: {
        state: {
          inUse: 'Faollashtirilgan',
          isFirst: 'Ustuvor',
          toFirst: 'Ustuvorlikni o\'rnating',
          inactive: 'Ta\'sirsiz'
        },
        periodUnits: {
          minute: 'daqiqa (lar)',
          hour: 'soat (lar)',
          day: 'kun (lar)',
          month: 'oy (lar)',
        },
        useIntro: {
          tip1: 'Cheksiz ma\'lumotlar to\'plami balandlikdagi ma\'lumotlar to\'plamiga qaraganda yuqori ustuvorlikka ega;',
          tip2: 'Foydalanish ustuvorligi bir xil turdagi to\'plamga asoslanadi, I.E., birinchi sotib olish sanasi bilan paket avvalgi paketdan foydalaniladi, bitta mintaqa paketlarining ustuvorligi mintaqaviy paketdan ustundir;',
          tip3: 'Siz shuningdek bir xil turdagi paketlardan foydalanish ustuvorligini qo\'lda sozlashingiz mumkin.'
        },
        myFlow: 'Mening oqimim',
        remainingFlow: 'Ma\'lumotlar qoldi',
        remainingTime: 'Haqiqiy chap',
        remainingHighFlow: 'Yuqori tezlikdagi ma\'lumotlar qoldi',
        validPeriod: 'Yaroqlilik',
        noneFlow: 'Ma\'lumot to\'plami yo\'q',
        noneFlowTip: 'Iltimos, ma\'lumotlar to\'plamini sotib oling va yuqori sifatli tarmoqdan bahramand bo\'ling',
        buyPackFlow: 'Paketlarni sotib olish',
        checkInvalidFlow: 'Muddati o\'tgan ma\'lumotlar to\'plamini tekshiring',
        orderList: {
          "title": "Mening buyurtmam",
          "amount_paid": "Jami",
          "device": "Egalik qurilmasi",
          "order_details": "Buyurtma tafsilotlari",
          "total_amont": "Subtotal",
          "orderSN": "Buyurtma yo'q.",
          "createTime": "Yaratilish vaqti",
          "cancelTime": "Yopiq vaqt",
          "payTime": "Buyurtma vaqti",
          "unsubTime": "Bekor qilingan vaqt",
          "payMethod": "To'lov usuli",
          "thirdSN": "Bitim yo'q.",
          "delete": "O'chirmoq",
          "cancel": "Buyurtmani bekor qilish",
          "unsub": "Qaytarmoq",
          "goto_cancel": "Buyurtmani bekor qilmoqchimisiz?",
          "goto_unsubscribe": "Buyurtmani bekor qilmoqchimisiz?",
          "delete_Tips": "Buyurtma o'chirilgandan so'ng buyurtma berilishi mumkin emas, shuning uchun sizning xizmatingiz muammolari hal qilinishi mumkin emas.Siz uni yo'q qilishga ishonchingiz komilmi?",
          "status_success": "Tugallangan",
          "status_pending": "To'lanmagan",
          "status_cancel": "Yopiq",
          "status_unsub": "Bekor qilindi",
          "payMethod_stripe": "Kredit kartasi"
        },
      },
      registerlogin: { 
        create_account_tip:"Hisob qaydnomasini yarating, eksklyuziv tajribani boshlang",
        select_country_tip:"Qurilma mamlakat / mintaqadan foydalanadi",
        email_name: 'Pochta',
        phone_name: 'Telefon',
        email_address: 'E-pochta manzili',
        password: 'parol',
        country: 'mamlakat',
        select_country: 'Mamlakatni tanlang',
        cancel: 'Bekor',
        confirm: 'Albatta',
        please_enter: 'Iltimos, 6-20 belgidan iborat belgini kiriting (harflar, raqamlar yoki belgilar)',
        select_country_tips: 'Mamlakat tanlash mahalliy paketlarni ko\'rish uchun.Ro\'yxatdan o\'tgandan keyin uni o\'zgartirib bo\'lmaydi.Iltimos, tasdiqlang!',
        global_roaming: 'Xalqaro domen kodi',
        phone_number: 'Telefon raqami',
        agree: 'rozi bo\'lmoq',
        user_agreement: 'Foydalanuvchi shartnomasi',
        and: 'va',
        privacy_policy: 'Maxfiylik siyosati',
        register_login: 'Ro\'yxatdan o\'tish yoki tizimga kiring',
        login_error: "Loginlar soni juda tez-tez, keyinroq qayta urinib ko'ring!",
        register_error: "Ro'yxatdan o'tish soni juda ko'p, iltimos, keyinroq qayta urinib ko'ring!",
        forgot_pwd: 'Parolni unuting',
        app_tips: 'Ushbu hisob qaydnomasi bilan ilovaga kiring, uni yuklab olgandan so\'ng uni yuklab oling.',
        download_app:'Ilovani yuklab olish uchun boring',
        rememberPwd: 'Parolni eslang',
        third_login: "Davom eting",
        agreement_tips: "Iltimos, foydalanuvchi shartnomasini va maxfiylik siyosati katakchasini tekshiring",
        selectCountry_tips: "Shuni ta'kidlang, ro'yxatdan o'tgan mamlakat quyidagi to'lov usullari va valyutalariga bevosita ta'sir qiladi, iltimos, kerakli ehtiyojlarga mos ravishda tanlang.",
        login_error_cancel: "Foydalanuvchi tizimga kirishni bekor qildi",
        login_error_auth: "Brauzer sozlamalaridan pop-up oynalarga ruxsat bering",
        device_tips: "Qurilma faollashtirilmagan. 24 soat ichida ishlov beramiz."
      },
      forgotPwd: {
        forgot_pwd: 'Parolni unuting',
        email_address: 'E-pochta manzili',
        next: 'Keyingisi',
        email_has_been_sent: 'Biz %@email raqamiga xat yubordik. Iltimos, havolani bosing va parolingizni olish uchun qadamlarni bajaring.',
        have_retrieved_it: 'Men buni topdim',
        unable_to_receive_email: 'E-pochtani olmaysizmi? Iltimos, spam va o\'chirilgan pochta katalogingiz ostida %@email dan xatlar bor yoki yo\'qligini tekshiring',
        or: 'yoki',
        resend: 'Qayta ko\'rib chiqmoq',
        global_roaming: 'Xalqaro domen kodi',
        phone_number: 'Telefon raqami',
        verification_code_has_been_sent: 'Biz tasdiqlash kodini quyidagi manzilga yubordik:',
        verification_code: 'Tasdiq kodi',
        no_verification_code_received: 'Tasdiqlash kodini olmadingizmi?',
        please_enter: 'Iltimos, 6-20 belgidan iborat belgini kiriting (harflar, raqamlar yoki belgilar)',
        reset_password: 'Parolni tiklash',
        reset_successful: 'Qayta tiklash muvaffaqiyatli',
      },
      coupons: {
        coupons_name: 'Kuponlar',
        no_coupons: "Hali kupon yo'q",
        no_data: "Hali ma'lumot yo'q",
        applicable_to_the_following:'Kuponlar quyidagi ma\'lumotlar to\'plami uchun mos keladi'
      },
      digital: {
        title: "Qurilma sn",
        purchased: "Mening xaridlarim",
        viewAll: "Ko'proq",
        skinStore: "Mahsulot do'koni",
        completed: "Sotib olingan",
        goBuy: "Sotib olmoq",
        order: {
            title: "Xarid qilingan buyurtmalar"
        },
        detail: {
            describe: "Tavsif"
        }
      },
      viewPL: {
        other: 'бошқа'
      },
      invalidFlow: {
        stateName: 'Holat',
        state: {
          NOT_ACTIVATED: "Ta'sirsiz",
          IN_USING: "Mavjud",
          USE_END: "Charchagan",
          EXPIRE: "Muddati o'tgan",
          TRANSFER: "O'tkazmoq",
          UNSUBSCRIBE: "Bekor qilmoq",
          VALID: "To'g'ri",
          INVALID: "Yaroqsiz",
          EXCHANGE_POINTS: "Ballarni qaytarish"
        },
        noneFlow: 'Muddati o\'tgan ma\'lumotlar to\'plami yo\'q',
        pageName: 'Muddati o\'tgan ma\'lumotlar to\'plami'
      },
      flowDetail: {
        title: 'Ma\'lumotlar ma\'lumotlari',
        flow: 'Ma\'lumotlar',
        validTime: 'Haqiqiy boshlanadi',
        invalidTime: 'Amal qiladi',
        coverage: 'Qoplama',
        useIntro: 'Foydalanish shartlari',
        purchaseTime: 'Sotib olingan',
        subtotal: 'Subtotal',
        status: 'Holat',
        cancel: 'Bekor qilmoq',
        buyAgain: 'Yana sotib oling',
        validity: 'Yaroqlilik',
        tip: 'E\'tibor',
        cancelTip: 'Ushbu paketni qaytarishni xohlayotganingizga ishonchingiz komilmi?',
        dataLeft: 'Ma\'lumotlar qoldi'
      },
      netError: {
        try_again: 'Qayta urinib ko\'ring',
        net_error: 'Tarmoq yo\'q',
        try_again_desc: 'Iltimos, tarmoq parametrini tekshiring va qaytadan urining'
      },
      loadFail: {
        try_again: 'Qayta urinib ko\'ring',
        load_fail: 'Yuklash muvaffaqiyatsiz tugadi',
        load_fail_desc: 'Ma\'lumotlar yuklanishi amalga oshmadi, iltimos yana urinib ko\'ring',
        IMEI_Not_Exist: 'IMEI mavjud emas, iltimos, kerakli kirishdan kirishga harakat qiling',
        Project_Not_Exist:'Xato yuzaga keladi.Iltimos, mijozlarga xizmat ko\'rsatish bilan bog\'laning. (01)',
        commonError:'Xato yuzaga keladi.Iltimos, mijozlarga xizmat ko\'rsatish bilan bog\'laning.',
      },
      settlement_Easy_and_convenient:"Oson va qulay",
      settlement_Great_deal:"Katta bitim",
      settlement_Safe_and_secure:"Xavfsiz va xavfsiz",
      settlement_Autopay_service_regulation:"Atopoy xizmatini tartibga solish",
      settlement_Read:"O'qimoq",
      settlement_No_coupon:"Mavjud kupon yo'q",
      settlement_Subtotal:"Subtotal",
      settlement_Coupon:"Kupon",
      settlement_TOTAL:"Jami",
      settlement_promotion_tip:"Reklama taklifi har qanday kupon bilan birgalikda ishlatib bo'lmaydi",
      settlement_coupon_tip:"Kupon boshqa har qanday reklama takliflari bilan birgalikda ishlatilishi mumkin emas",
      member_myFlow_noList:"Ma'lumot yo'q",
      detail_se_content:"Xavfsiz, oson va qulay usul.Siz istalgan vaqtda obunani bekor qilishingiz mumkin",
      Enter_Promo_code:"Rag'batlantirish kodi",
      Enter_Promo_Coupon:"Kuponlar",
      settlement_Not_used_coupon:"Kupon ishlatilmaydi",
      settlement_Available_coupon:"Mavjud",
      settlement_Unavailable_coupon:"Erishib bo'lmaydigan",
      please_Enter_Promo_code:"Iltimos, reklama kodini kiriting",
      please_Select_Coupon_use: "Iltimos, foydalanmoqchi bo'lgan kuponni tanlang.",
      Buy_Now:"Hozir xarid qilish",
      Dont_Use_Any:"Hech narsa ishlatmang",
      settlement_confirm:"Tasdiqlamoq",
      settlement_tips:"Tasdiqlamoq",
      flowDetail_unsubscribe: "Obunani bekor qiling",
      flowDetail_unsubscribed: "Tugatilmagan",
      flowDetail_isCancelPackage: "Ushbu to'plamni bekor qildingizmi?",
      flowDetail_confirmAgreementUnsubscribe : "Obunani bekor qilgandan keyin siz juda ko'p narsa qila olmaysiz.Haqiqatan ham obunani bekor qilmoqchimisiz?",
      flowDetail_cancel: "Bekor qilmoq",
      flowDetail_cancelSuccess: "Obunachasini muvaffaqiyatli bekor qiling",
      packages_detail_promotion:"Reklama",
      orderTips:{
        "iDay" : "kun",
        "iDays" : "kunlar",
        "iMonth" : "oy",
        "iMonths" : "oylar",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Birinchi sotib olishda, Keyinchalik %@money/%@periodSymbol to'lash, Siz istalgan vaqtda obunani bekor qilishingiz mumkin",
        'Monthly_discount':"Har bir %@saveMoney ni saqlang %@period! Istalgan vaqtda obunani bekor qilishingiz mumkin ",
        'Ordinary_monthly_package':"Xavfsiz, oson va qulay usul.Siz istalgan vaqtda obunani bekor qilishingiz mumkin",
        "AlreadyPurchased":"Ayni paytda faqat bitta ma'lumot to'plamiga obuna bo'lishingiz mumkin.Iltimos, “%@” ni bekor qiling va keyinchalik u tugaganidan keyin xohlagan har qanday paketga obuna bo'ling.",
        "Contract_recommendation_First":"<label>Avtopey xizmati bilan, birinchi sotib oling, faqat to'lash</label>"
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Siz istalgan vaqtda obunani bekor qilishingiz mumkin'
        +'<a class="btn">Obuna bo\'lish ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Faqat avtoulov xizmati bilan faqat to'lang</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Siz istalgan vaqtda obunani bekor qilishingiz mumkin'
        +'<a class="btn">Obuna bo\'lish ></a></p>',
        "Contract_recommendation_General":"<label>Atopay xizmati bilan</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Xavfsiz, oson va qulay usul.Siz istalgan vaqtda obunani bekor qilishingiz mumkin'
        +'<a href="javascript:;" class="btn">Obuna bo\'lish ></a></p>',
        'BanlanceDoubleCheck':"Haqiqatan ham balans bilan to'lashni xohlaysizmi?",
    },
    feedback: {
      title: "fikr-mulohaza",
      placeholder: "Iltimos, tashrif buyurmoqchi bo'lgan mamlakatga yoki boshqa savollarni kiriting va biz sizning ehtiyojlaringizni iloji boricha tezroq qondiramiz!",
      submit: "Yuborish",
      submit_success: "Muvaffaqiyatli topshirish",
      other_opinions: "Boshqa fikrlar",
    },
    view_country_input: 'Iltimos, hisob qaydnomangizni kiriting',
    select_package: {
      title: "Ma'lumot Tanlang",
      allPackage: 'Barcha Ma\'lumotlar',
      type: "Turp",
      flow: "Ma'lumot",
      month_package: "Oylik Plani",
      flow_package: "Ma'lumot Paketi",
      time: "Davomiylik",
      period: "Tsikl",
      auto_debit: "Avtodetal Mualifot",
      auto_subscribe: "Avto-Yangilash",
      detail: "Ma'lumot Detallari",
      carrier: "Desteklangan Provayderlar",
      country: "Kapsalgan Davlatlar",
      notice: "Xarid qo'llanmasi"
    }
}